import styled from 'styled-components'
import { color } from '@libs/theme/mixins'
import { Stepper } from '@libs/components'

const FormWrapper = styled.div`
	.ant-form-item-required {
		svg {
			order: -1;
		}
	}

	label > svg:hover {
		color: ${color(['primary', '500'])};
	}
`

const CustomStepper = styled(Stepper)`
	> *:first-child {
		display: none;
	}
`

export default {
	FormWrapper,
	CustomStepper,
}
